export const ASSIGNABLE_SETTINGS_TABS = [
  { tabKey: "application", labelKey: "Application" },
  { tabKey: "tracking", labelKey: "Tracking" },
  { tabKey: "emailReport", labelKey: "Periodic Report Email" },
  { tabKey: "analytics", labelKey: "Dashboard Analytical Display" },
  { tabKey: "theme", labelKey: "Theme & Icons" },
];

export const ASSIGNABLE_SETTINGS_TAB_KEYS = ASSIGNABLE_SETTINGS_TABS.map(
  (tab) => tab.tabKey,
);

export function isOrganizationSettingsTabEnabled(tabKey, enabledSettingsTabs) {
  if (!ASSIGNABLE_SETTINGS_TAB_KEYS.includes(tabKey)) {
    return true;
  }
  if (!Array.isArray(enabledSettingsTabs)) {
    return true;
  }
  return enabledSettingsTabs.includes(tabKey);
}

export const SETTINGS_TAB_VALUE_BY_KEY = {
  application: 0,
  tracking: 1,
  emailReport: 2,
  analytics: 3,
  theme: 4,
  labels: 5,
  advertisements: 6,
};

const LEGACY_SETTINGS_TABS = [
  {
    tabKey: "application",
    labelKey: "Application",
    value: 0,
    translateLabel: true,
  },
  {
    tabKey: "tracking",
    labelKey: "Tracking",
    value: 1,
    translateLabel: true,
  },
  {
    tabKey: "emailReport",
    labelKey: "Periodic Report Email",
    value: 2,
    translateLabel: true,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "analytics",
    labelKey: "Dashboard Analytical Display",
    value: 3,
    translateLabel: true,
    permission: { apiPath: "/api/managedata/analytics", action: "GET" },
  },
  {
    tabKey: "theme",
    labelKey: "Theme & Icons",
    value: 4,
    translateLabel: true,
  },
  {
    tabKey: "labels",
    labelKey: "Labels",
    value: 5,
    translateLabel: true,
    superAdminOnly: true,
  },
  {
    tabKey: "advertisements",
    labelKey: "Advertisements",
    value: 6,
    translateLabel: true,
  },
];

export function hasSettingsTabPermission(permission, features) {
  if (!permission?.apiPath) {
    return true;
  }
  if (!features) {
    return false;
  }
  return features.some((feature) => feature.api_path === permission.apiPath);
}

function resolveTabLabel(tab, t) {
  if (!tab.translateLabel) {
    return tab.labelKey;
  }
  return t(tab.labelKey);
}

function filterSettingsTabs(tabs, { isSuperAdmin, school, features, enabledSettingsTabs }) {
  const baseTabs = isSuperAdmin ? tabs : tabs.filter((tab) => !tab.superAdminOnly);

  return baseTabs
    .filter((tab) => !school || !tab.hideForSchool)
    .filter((tab) => hasSettingsTabPermission(tab.permission, features))
    .filter((tab) =>
      isOrganizationSettingsTabEnabled(tab.tabKey, enabledSettingsTabs),
    );
}

export function getLegacySettingsTabs({
  t,
  isSuperAdmin,
  school,
  features,
  enabledSettingsTabs,
}) {
  return filterSettingsTabs(LEGACY_SETTINGS_TABS, {
    isSuperAdmin,
    school,
    features,
    enabledSettingsTabs,
  }).map((tab) => ({
    ...tab,
    label: resolveTabLabel(tab, t),
  }));
}
